import {Injectable} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {FormGroup, Validators} from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class DynamicFormValidationService {

    constructor() {
    }

    // setup the form
    buildFormGroup(dataObject, formGroup?) {
        formGroup = formGroup || {};
        for (const key of Object.keys(dataObject)) {
            const valueObj = dataObject[key];
            if (valueObj.isFormGroup) {
                // create new form group for configObj
                const subGroup = valueObj.group || {};
                // for the props in configObj create form control
                formGroup[key] = this.buildFormGroup(subGroup);

            } else {
                // if not a form group create form control within same form group
                formGroup[key] = new FormControl(valueObj.value || '', this.mapValidators(valueObj.validation));
            }
        }

        return new FormGroup(formGroup) || null;
    }

     // setup the edit form
     buildEditFormGroup(dataObject, formData, formGroup?) {
        formGroup = formGroup || {};
        for (const key of Object.keys(dataObject)) {
            const valueObj = dataObject[key];
            if (valueObj.isFormGroup) {
                // create new form group for configObj
                const subGroup = valueObj.group || {};
                // for the props in configObj create form control
                formGroup[key] = this.buildFormGroup(subGroup);

            } else {
                // if not a form group create form control within same form group
                formGroup[key] = new FormControl(formData.hasOwnProperty(valueObj.value) ? formData[valueObj.value] : '', this.mapValidators(valueObj.validation));
            }
        }

        return new FormGroup(formGroup) || null;
    }

    private mapValidators(validatorsObj) {
        const formValidators = [];

    if (validatorsObj) {
      for (const validationKey of Object.keys(validatorsObj)) {
        if (validationKey === 'required' && validatorsObj[validationKey]) {
          formValidators.push(Validators.required);
        } else if (validationKey === 'min') {
          formValidators.push(Validators.min(validatorsObj[validationKey]));
        } else if (validationKey === 'pattern') {
            formValidators.push(Validators.pattern(validatorsObj[validationKey]));
        }
      }
    }

        return formValidators;
    }

    /**
     * Takes the input as the list of error messages and filters out the
     * @param dataObject
     * @param errors
     */
    buildFormAndFieldErrors(dataObject: Object, errors) {
        errors = errors || [];
        const errorsMap = {
            fieldErrorsMap: {},
            formErrors: []
        };
        const errorFieldsMap = this.buildFieldsMapForIteration(dataObject, 'errorField');
        errors.forEach(error => {
            const errorFieldFromResponse = error.field;
            const fieldName = errorFieldsMap[errorFieldFromResponse];
            if (fieldName) {
                errorsMap.fieldErrorsMap[fieldName] = error;
            } else {
                errorsMap.formErrors.push(error);
            }
        });
        return errorsMap;

    }

    private buildFieldsMapForIteration(dataObject: Object, errorFieldName: string) {
        const result = {};
        dataObject = dataObject || {};
        for (const config of Object.keys(dataObject)) {
            const key = config;
            const value = dataObject[key];
            if (value.isFormGroup) {
                const nestedResult = this.buildFieldsMapForIteration(value.group, errorFieldName);
                if (nestedResult) {
                    Object.assign(result, nestedResult);
                }
            } else if (value[errorFieldName]) {
                result[value[errorFieldName]] = key;
            }
        }
        return result;
    }

    findFieldControl(field: string, form: FormGroup): AbstractControl {
        let control: AbstractControl;
        if (field === 'base') {
            control = form;
        } else if (form.contains(field)) {
            control = form.get(field);
        } else if (field.match(/_id$/) && form.contains(field.substring(0, field.length - 3))) {
            control = form.get(field.substring(0, field.length - 3));
        } else if (field.indexOf('.') > 0) {
            let group = form;
            field.split('.').forEach((f) => {
                if (group.contains(f)) {
                    control = group.get(f);
                    if (control instanceof FormGroup) { group = control; }
                } else {
                    control = group;
                }
            });
        } else {
            // Field is not defined in form but there is a validation error for it, set it globally
            control = form;
        }
        return control;
    }

    getFormControl(controlName, formGroup) {
        return this.findFieldControl(controlName, formGroup);
    }

    getFormControlValue(controlName: string, formGroup: FormGroup) {
        const currControlInstance = this.getFormControl(controlName, formGroup);
        if (currControlInstance) {
            return currControlInstance.value;
        }
        return null;
    }

    setFormControlValue(controlName: string, formGroup: FormGroup , value: any) {
        const currControlInstance = this.getFormControl(controlName, formGroup);
        if (currControlInstance) {
            currControlInstance.setValue(value);
        }
    }

    hasError(controlName: string, formGroup: FormGroup , validatorName: string) {
        const currControlInstance = this.getFormControl(controlName, formGroup);
        return currControlInstance.hasError(validatorName);
    }

    isFormSubmittedOrTouched(controlName: string, formGroup: FormGroup , isSubmitClicked: boolean) {
        const currControlInstance = this.getFormControl(controlName, formGroup);
        return (isSubmitClicked || currControlInstance.dirty || currControlInstance.touched);
    }

}
